import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {useQueryClient} from 'react-query'
import {toast} from 'react-toastify'
import {patchOne} from '../../../../../services/common_requests'
import {QUERIES} from '../../../../../../_dashboard/helpers'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {Hotel} from '../../core/_models'

type Props = {
  hotel: Hotel & {_id?: string; hotel_id?: string; isActive?: boolean; name?: string}
}

const HotelActiveCell: FC<Props> = ({hotel}) => {
  const intl = useIntl()
  const {query, refetchData} = useQueryResponse()
  const queryClient = useQueryClient()
  const [saving, setSaving] = useState(false)
  const isActive = hotel?.isActive !== false

  const toggle = async () => {
    if (!hotel?._id || saving) return
    const next = !isActive
    try {
      setSaving(true)
      await patchOne({isActive: next}, `/hotels/${hotel._id}`)
      toast.success(
        next
          ? intl.formatMessage({
              id: 'HOTEL.ACTIVATED',
              defaultMessage: 'Hôtel activé (visible sur le front)',
            })
          : intl.formatMessage({
              id: 'HOTEL.DEACTIVATED',
              defaultMessage: 'Hôtel désactivé (masqué du front)',
            }),
      )
      queryClient.invalidateQueries([`${QUERIES.HOTELS_LIST}-${JSON.stringify(query)}`])
      refetchData?.()
    } catch (e) {
      toast.error(
        intl.formatMessage({
          id: 'HOTEL.ACTIVE_TOGGLE_ERROR',
          defaultMessage: 'Impossible de modifier le statut de l’hôtel',
        }),
      )
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className='form-check form-switch form-check-custom form-check-solid'>
      <input
        className='form-check-input'
        type='checkbox'
        checked={isActive}
        disabled={saving}
        onChange={toggle}
        id={`hotel-active-${hotel?._id}`}
        title={
          isActive
            ? intl.formatMessage({
                id: 'HOTEL.ACTIVE_HINT',
                defaultMessage: 'Visible sur le front-office',
              })
            : intl.formatMessage({
                id: 'HOTEL.INACTIVE_HINT',
                defaultMessage: 'Masqué du front-office',
              })
        }
      />
      <label className='form-check-label text-muted fs-8' htmlFor={`hotel-active-${hotel?._id}`}>
        {isActive
          ? intl.formatMessage({id: 'COMMON.YES', defaultMessage: 'Oui'})
          : intl.formatMessage({id: 'COMMON.NO', defaultMessage: 'Non'})}
      </label>
    </div>
  )
}

export {HotelActiveCell}
